export const doesCampaignLabelMatchSearch = (label: string, id: number, search: string) =>
  search.length === 0 || // Pass all options through if search string is empty
  id.toString().includes(search.toLowerCase()) || // Pass options with matching IDs
  label.toLowerCase().includes(search.toLowerCase()); // Pass options with matching names
